export default __webpack_public_path__ + "static/media/3ab0712c0558988be47f839dfd846186.png";